<template>
  <div class="container roundedBorder secondary-bg primary-fg" style="padding: 20px;">
    <div class>
      <h2 class>LockerApp</h2>
      <p class="lead">
        LockerApp is a
        <b class="secondary-fg">mobile / web application</b> which lets you protect your
        <b class="secondary-fg">passwords</b>
 of your
        social
        media accounts, email accounts and much more, you can keep your notes secret as well. Only you
        can access them with your password or your own unique finger print from your phone or web browser.
      </p>
      <hr class="my-4 seperator" />
      <p class="lead">
        Your privacy is valuable, other than keeping your data safe, we encrypt your data too. Thus, only you can truly see the data you have stored.
      </p>
      <hr class="my-4 seperator" />

      <router-link to="/signup">
        <p class="lead">
          <a class="btn primary-bg" role="button">Create a new account</a>
        </p>
      </router-link>
      <p class="lead">
        <a
          class="btn primary-bg"
          href="mailto:lockerApp.contact@gmail.com?subject=LockerApp contact&body=Dear LockerApp Team,"
          role="button"
        >Contact LockerApp</a>
      </p>
      <router-link to="/">
        <p class="lead">
          <a class="btn primary-bg" role="button">Back to homepage</a>
        </p>
      </router-link>
    </div>
  </div>
</template>

<script>

export default {
  name: 'About',
  metaInfo: {
    title: 'About',
    meta: [
      {name: 'description', content: 'LockerApp is a mobile / web application which lets you protect your passwords of your social media accounts, email accounts and much more, you can keep your notes secret as well. | LockerApp | Password Manager | Encrypted Passwords | Encrypted Notes | Generate a new strong password'},
      {name: 'application-name', content: 'LockerApp'},
      {name: 'author', content: 'Emre Biçer'},
      {name: 'keywords', content: 'LockerApp, Locker App, Locker, App, Password Manager, Password, Safe, Application, Last Password, Locker, Notes, Note Application, Mobile Application, Web Application'}
    ]
  }
}
</script>
